import React from 'react';

const LoadingSpinner = ({ text = 'Loading...' }) => {
  return (
    <div className="loading-spinner">
      <div className="text-center">
        <div className="spinner mb-3"></div>
        <p className="text-muted">{text}</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
